var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8001 7.33328H14L15.2666 14.6666H0.599945L1.93328 7.33328H4.13347C2.86681 5.53327 3.06668 2.99995 4.66668 1.39995C6.46668 -0.400054 9.46661 -0.400054 11.2666 1.39995C12.8666 2.99995 13.0668 5.53327 11.8001 7.33328ZM9.93328 2.79995C8.86661 1.73329 7.20014 1.73329 6.13347 2.79995C5.06681 3.79995 5.06655 5.53327 6.19988 6.59994L8.06675 8.46661L9.93328 6.59994C10.9999 5.53327 10.9999 3.86662 9.93328 2.79995ZM3.66668 9.33328L3.06675 12.6666H12.9333L12.3333 9.33328H9.93328L8.00001 11.2666L6.06675 9.33328H3.66668ZM9.00001 4.66665C9.00001 5.21893 8.55228 5.66665 8.00001 5.66665C7.44774 5.66665 7.00001 5.21893 7.00001 4.66665C7.00001 4.11436 7.44774 3.66665 8.00001 3.66665C8.55228 3.66665 9.00001 4.11436 9.00001 4.66665Z",
    fill: "#7B7B7B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.b770038befac3b8b76033c2b0f55787a.svg";
export { ForwardRef as ReactComponent };